// Kept identical to tcs-fse/src/utils/expertLink/expertLink.ts.
import { EXPERTLINK_BRAND, EXPERTLINK_CATEGORY_KEY } from './consts';

export interface IExpertLinkMachineEligibility {
  vin?: string;
  brand?: string;
  categoryKey?: string;
}

export const isExpertLinkEligible = ({ vin, brand, categoryKey }: IExpertLinkMachineEligibility): boolean => {
  const hasVin = !!vin;
  const isMasseyFerguson = brand === EXPERTLINK_BRAND;
  const isTractor = categoryKey?.toLowerCase() === EXPERTLINK_CATEGORY_KEY;

  return hasVin && isMasseyFerguson && isTractor;
};
